import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24b70650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-upload-image" }
const _hoisted_2 = { key: 0 }

import { ref, watch, computed } from 'vue'

import { isEmpty } from "@/utils/util";
import { getToken } from '@/utils/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'image-upload',
  props: {
    visible: { type: Boolean, default: false },
    action: { default: '' },
    value: { default: [String, Object, Array] },
    fileSize: { default: 5 },
    fileType: { default: ['png', 'jpg', 'jpeg'] },
    isShowTip: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    limit: { default: 3 }
  },
  emits: ['fileUpload',],
  setup(__props: any, { emit }) {

const props = __props;

// list-type="picture-card" 

const uploadFileUrl = process.env.VUE_APP_BASE_URL + '/evaluate//file/oss-upload'

const headers = {
  Authorization: "Bearer " + getToken()
}
const fileList = ref([])


const showTip = computed(() => props.isShowTip && (props.fileType || props.fileSize))
const fileTypeLIst = computed(() => props.fileType.map(item => ('.' + item)))





// 上传前校检格式和大小
const handleBeforeUpload = (file) => {
  // 校检文件类型
  if (props.fileType) {
    let fileExtension = "";
    if (file.name.lastIndexOf(".") > -1) {
      fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
    }

    const isTypeOk = props.fileType.some((type) => {
      if (file.type.indexOf(type) > -1) return true;
      if (fileExtension && fileExtension.indexOf(type) > -1) return true;
      return false;
    });
    if (!isTypeOk) {
      // props.msgError(
      //   `文件格式不正确, 请上传${props.fileType.join("/")}格式文件!`
      // );
      console.log(`文件格式不正确, 请上传${props.fileType.join("/")}格式文件!`);

      return false;
    }
  }
  // 校检文件大小
  // if (props.fileSize) {
  //   const isLt = file.size / 1024 / 1024 < Number(props.fileSize);
  //   if (!isLt) {
  //     // this.msgError(`上传文件大小不能超过 ${props.fileSize} MB!`);
  //     console.log(`上传文件大小不能超过 ${props.fileSize} MB!`);
  //     return false;
  //   }
  // }
  return true;
}

// 文件个数超出
const handleExceed = () => {
  // this.msgError(`只允许上传${this.limit}个文件`);
  console.log(`只允许上传${props.limit}个文件`);

}
// 上传失败
const handleUploadError = (err) => {
  // this.msgError("上传失败, 请重试");
}
// 上传成功回调
const handleUploadSuccess = (res, file, fileList) => {
  // this.msgSuccess("上传成功");
  emit("fileUpload", fileFilter(fileList));
}
// 删除文件
const handleDelete = (file, fileList) => {
  // this.$emit("fileUpload", this.fileFilter(fileList));
  emit("fileUpload", fileFilter(fileList));

}
// 获取文件名称
const getFileName = (name) => {
  if (name.lastIndexOf("/") > -1) {
    return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
  } else {
    return "";
  }
}
const fileFilter = (file) => {
  if (isEmpty(file)) {
    return [];
  } else {
    let fileList = [];
    file.map((val) => {
      if (isEmpty(val.response)) {
        // fileList.push({
        //   name: val.name,
        //   url: val.url.slice(this.imageServerIp.length),
        //   enclosureId: val.enclosureId
        // });
      } else {
        fileList.push({
          name: val.name,
          url: val.response.fileName,
          enclosureId: val.response.enclosureId
        });
      }
    });
    return fileList;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      action: uploadFileUrl,
      "on-success": handleUploadSuccess,
      "before-upload": handleBeforeUpload,
      "on-error": handleUploadError,
      limit: _ctx.limit,
      "on-exceed": handleExceed,
      "file-list": fileList.value,
      accept: fileTypeLIst.value.join(','),
      "on-remove": handleDelete,
      headers: headers,
      style: {"display":"inline-block","vertical-align":"top"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "mini",
          disabled: _ctx.disabled
        }, {
          default: _withCtx(() => [
            _createTextVNode("选取文件")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["limit", "file-list", "accept"]),
    (fileList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_image, {
              class: "vx-lazyLoad",
              key: index,
              src: item.url,
              lazy: "",
              "preview-src-list": [item.url],
              "z-index": 3000
            }, null, 8, ["src", "preview-src-list"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})